import React from 'react';
import {connect} from 'react-redux';
import {Modal as Component} from './Modal';
import {
  setModal,
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

import {
  GlossaryProvider
} from "@learningblocks/storybook-components";

import {
  getIndividualGlossaryItem,
  getIndividialDataFromAirtable,
  API_DETAILS,
} from '@learningblocks/exp-constants/lib/Utilities';

const GlossaryHOC = (props) => {

  const getGlossaryItem = () =>
  getIndividualGlossaryItem(
    getIndividialDataFromAirtable,
    API_DETAILS.URL,
    API_DETAILS.KEY
  );

  const {onOpenGlossary} = React.useContext(GlossaryProvider.Context);

  return (
    <Component
      {...props}
      getGlossaryItem={getGlossaryItem}
      onOpenGlossary={onOpenGlossary}
    />
  )
}

function mapStateToProps(state, ownProps) {

    return {
      display: state.notebook.protocolSection.scene.modal.display,
      type: state.notebook.protocolSection.scene.modal.type,
      size: state.notebook.protocolSection.scene.modal.size,
      connect: state.notebook.protocolSection.scene.modal.connect,
      data: state.notebook.protocolSection.scene.modal.data,

      pipetteId: state.notebook.protocolSection.scene.modal.pipetteId,
      gelId: state.notebook.protocolSection.scene.modal.gelId,
      gelBoxId: state.notebook.protocolSection.scene.modal.gelBoxId,
      noteEntryOpen: state.notebook.protocolSection.scene.noteEntryOpen,
      sectionSelected: state.notebook.protocolSection.scene.sectionSelected,

      drawerOpen: !state.notebook.notebookCollapsed,
    }

}

function mapDispatchToProps(dispatch) {
  return {
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const Modal = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlossaryHOC);
